require("./theme.css");

import Vue from 'vue'
Vue.config.productionTip = false

import store from './store';
import router from './router';

import App from './App.vue'
new Vue({
    router: router,
    store: store,
    render: h => h(App)
}).$mount('#app')
